import { StyleSheet } from 'react-native';
import { isValidObject, tokens, useBreakpoint } from '@airtel/air-design-system';
var spacingToken = tokens.spacing;
export var getPageHeaderWidgetStyles = props => {
  var _a;
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var validActionIcons = isValidObject(props === null || props === void 0 ? void 0 : props.actionIconsProps) && ((_a = props === null || props === void 0 ? void 0 : props.actionIconsProps) === null || _a === void 0 ? void 0 : _a.length) > 0 ? true : false;
  return StyleSheet.create({
    outerContainer: {
      flexDirection: 'row',
      width: '100%'
    },
    titleInfoTagContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: isLargeScreen ? spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_8 : spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_5
    },
    rightContainer: {
      marginRight: spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_0,
      marginLeft: 'auto'
    },
    ctaContainer: {
      flexDirection: 'row'
    },
    actionIconContainer: {
      flexDirection: 'row',
      marginLeft: validActionIcons ? spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_16 : spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_0
    },
    buttonContainer: {
      alignItems: 'center',
      flexDirection: 'row'
    },
    topMarginThree: {
      marginTop: spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_3
    },
    leftMarginEight: {
      marginLeft: spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_8
    },
    leftMarginFourteen: {
      marginLeft: spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_14
    },
    leftMarginSixteen: {
      marginLeft: spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_16
    }
  });
};